var settingsConfig = {
    num_incidencia: '2000003333',
    canal: 'F6'
};

module.exports = {
    settingsConfig: settingsConfig
};


//////////////////
// WEBPACK FOOTER
// ./config/settings.js
// module id = ./config/settings.js
// module chunks = 34